
import { useContext } from 'react';
import { IconWarning } from '../img'
import { Signature } from '../components'
import { DataContext } from '../data/DataContext';

const Step6 = () => {
    const { ReclamosInspeccionNI, setReclamosInspeccionNI } = useContext(DataContext);

    const change = (newImg: string, isModified: boolean) => {
        setReclamosInspeccionNI({ ...ReclamosInspeccionNI, signature: newImg, signatureIsModified: isModified })
    }

    const changeDriver = (newImg: string, isModified: boolean) => {
        setReclamosInspeccionNI({ ...ReclamosInspeccionNI, signatureDriver: newImg, signatureDriverIsModified: isModified })
    }
    return (
        <>
            <div className="mt-10" >
                <span className="lbl-input-re-ni " style={{ fontWeight: 600 }}>Antes de crear tu trámite, recordar al asegurado estos puntos:</span>
            </div>
            <div className="mt-10 info-group">
                <IconWarning />
                <span className='lbl-input-re-ni '>Podemos solicitarle inspeccionar personalmente los daños ocasionados a su vehículo</span>
            </div>
            <div className="mt-10 info-group">
                <IconWarning />
                <span className='lbl-input-re-ni '>Al crear este trámite, haces constar que las declaraciones ingresadas en este formulario son correctas, verídicas y que cualquier declaración falsa o inexacta podría anular este reclamo y la póliza afectada</span>
            </div>
            <div className="mt-10 info-group">
                <IconWarning />
                <span className='lbl-input-re-ni '>El completar este formulario no significa reconocimiento de los derechos que eventualmente ampara la póliza, ni aceptación de hechos en que pueda fundarse este reclamo. Seguros LAFISE te notificará su resolución por cualquier medio (fisico o digital) después del análisis del caso</span>
            </div>
            <div className="mt-10 info-group">
                <IconWarning />
                <span className='lbl-input-re-ni '>El cliente no debe reparar los daños ocasionados por el accidente a tu vehículo, hasta que Seguros LAFISE le entregue la resolución, de lo contrario, La Compañía no asumira el costo de reparación</span>
            </div>
            <Signature
                onChange={changeDriver}
                id='signatureDriver'
                value={ReclamosInspeccionNI.signatureDriver}
                text1='Firma del conductor'
                text2='Esta firma digital, debe ser lo más parecido a la que se muestra en el documento de identidad vigente del cliente.'              
            />
            <Signature
                onChange={change}
                id='signature'
                value={ReclamosInspeccionNI.signature}
                text1='Firma del asegurado y/o dueño'
                text2='Esta firma digital, debe ser lo más parecido a la que se muestra en el documento de identidad vigente del cliente.'
                isRequired={false}
            />
        </>)

}

export { Step6 }